export default __webpack_public_path__ + "57b014b9bcacf31fe542ecdb88090575.png";